module.exports = __webpack_public_path__ + "img/location_blue.78e6fa91.svg";